import { loggable } from '@wsbc/ux-lib';
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.4.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { HttpEvent, HttpRequest } from '@angular/common/http';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class WorkerEligibilityQuizApiClientBase {
  // The base class is used for customization
  activeOrg = null;

  protected http: any = null;
  protected baseUrl: string = '';

  // reference implementation about file upload API,
  //since swagger code gen is working correctly
  public uploadFile(
    eiiReportId: number,
    file: File,
  ): Observable<HttpEvent<DocumentUploadResponse>> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('eiirReportId', eiiReportId.toString());

    const options = {
      reportProgress: true,
    };

    const req = new HttpRequest(
      'PUT',
      `${this.baseUrl}/api/v1/Attachments/upload`,
      formData,
      options,
    );

    // break the line to prevent unintended update by codegen
    const http = this.http;
    return http.request(req);
  }

  // demo code how to hook into generated code
  transformOptions(option: any): Promise<any> {
    const { body } = option;

    if (body instanceof File) {
      const formData = new FormData();
      formData.append('uploadedFile', body, body.name);
      return Promise.resolve(formData);
    }

    return Promise.resolve(option);
  }

  // demo code how to hook into generated code
  transformRequest<T>(
    httpClient: HttpClient,
    op: string,
    url: string,
    options: any,
  ) {
    if (options instanceof FormData) {
      //const headers = new HttpHeaders({ 'iab': `${this.activeOrg}` });
      return httpClient.post(url, options, {
        observe: 'response',
        responseType: 'blob' /*, headers*/,
      });
    }
    return httpClient.request(op, url, options);
  }
}

export interface IWorkerEligibilityQuizApiClient {
    /**
     * @param file (optional) 
     * @return Success
     */
    uploadAttachment(file: FileParameter | undefined): Observable<DocumentUploadResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submitCase(version: string, body: RuwMessage | undefined): Observable<SubmitRuwMessageResponse>;
    /**
     * @return Success
     */
    version(version: string): Observable<VersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class WorkerEligibilityQuizApiClient extends WorkerEligibilityQuizApiClientBase implements IWorkerEligibilityQuizApiClient {
    
    
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param file (optional) 
     * @return Success
     */
     @loggable('WorkerEligibilityQuiz', 'api', 'WorkerEligibilityQuiz.uploadAttachment') uploadAttachment(file: FileParameter | undefined) : Observable<DocumentUploadResponse> {
        let url_ = this.baseUrl + "/api/v1/Attachment/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.transformRequest(this.http,"put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachment(<any>response_);
                } catch (e) {
                    return <Observable<DocumentUploadResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentUploadResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUploadAttachment(response: HttpResponseBase): Observable<DocumentUploadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DocumentUploadResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentUploadResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
     @loggable('WorkerEligibilityQuiz', 'api', 'WorkerEligibilityQuiz.submitCase') submitCase(version: string, body: RuwMessage | undefined) : Observable<SubmitRuwMessageResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Ruw/SubmitCase";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.transformRequest(this.http,"post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitCase(<any>response_);
                } catch (e) {
                    return <Observable<SubmitRuwMessageResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubmitRuwMessageResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitCase(response: HttpResponseBase): Observable<SubmitRuwMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SubmitRuwMessageResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitRuwMessageResponse>(<any>null);
    }

    /**
     * @return Success
     */
     @loggable('WorkerEligibilityQuiz', 'api', 'WorkerEligibilityQuiz.version') version(version: string) : Observable<VersionDto> {
        let url_ = this.baseUrl + "/api/v{version}/Version";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.transformRequest(this.http,"get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersion(<any>response_);
                } catch (e) {
                    return <Observable<VersionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VersionDto>><any>_observableThrow(response_);
        }));
    }

    protected processVersion(response: HttpResponseBase): Observable<VersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VersionDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VersionDto>(<any>null);
    }
}

export interface ContactInfo {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
}

export interface DocumentUploadResponse {
    id: string;
}

export interface EmployerInformation {
    industry: string;
    employerName: string;
}

export interface GpsAddress {
    addressAdditionalInstructions: string;
}

export interface IncidentDetails {
    description: string;
    locationType: string;
    streetAddress: StreetAddress;
    notSureAddress: NotSureAddress;
    gpsAddress: GpsAddress;
    date: string;
    time: string;
    isIssueOngoing: string;
}

export interface NotSureAddress {
    addressAdditionalInstructions: string;
}

export interface ProblemDetails {
    type: string;
    title: string;
    status: number | null;
    detail: string;
    instance: string;
}

export interface RuwMessage {
    caseTitle: string;
    businessReference: string;
    contactInfo: ContactInfo;
    incidentDetails: IncidentDetails;
    employerInformation: EmployerInformation;
    files: { [key: string]: string; } | null;
    recaptureResponse: string;
}

export interface StreetAddress {
    address: string;
    city: string;
    province: string;
    postalCode: string;
    addressAdditionalInstructions: string;
}

export interface SubmitRuwMessageResponse {
    data: RuwMessage;
    referenceId: string;
}

export interface VersionDto {
    version: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
